export function formatPriceK(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '-';
  return String(Math.floor(value / 1000));
}
